import { MobileShell as SharedMobileShell } from "@shared/components/MobileShell";
import { DataUseAcknowledgmentModal } from "@shared/components/DataUseAcknowledgmentModal";
import { BottomTabBar } from "../components/BottomTabBar";
import { WalkthroughProvider } from "../walkthrough/WalkthroughContext";
import { WalkthroughOverlay } from "../walkthrough/WalkthroughOverlay";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Home",
  "/schedule": "My Schedule",
  "/log-activity": "Log Activity",
  "/messages": "Messages",
  "/me": "Profile",
};

export function MobileShell() {
  return (
    <WalkthroughProvider>
      <SharedMobileShell
        routeTitles={ROUTE_TITLES}
        tabBar={(unreadCount) => <BottomTabBar unreadCount={unreadCount} />}
      >
        <WalkthroughOverlay />
        <DataUseAcknowledgmentModal
          title="Acceptable Use Policy"
          subtitle="Please review and acknowledge the following policy to continue."
          roles={["admin", "director", "teacher"]}
        />
      </SharedMobileShell>
    </WalkthroughProvider>
  );
}
